<template>
    <div v-if="productData">
        <h3 class="learnworlds-heading3 learnworlds-heading3-normal learnworlds-element">{{componentName}}</h3>            
        <div class="mb-3rem with-flexible-parts js-lw-flexible-wrapper  js-same-content-child">
            <span data-node-type="icon" class="flexible-part   learnworlds-icon learnworlds-overline-text fas fa-tags"></span>
            <div class="flexible-part">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom" >
                    Coupon
                </div>
                <div v-if="activeCoupon==null" class="learnworlds-main-text  learnworlds-main-text-large learnworlds-element">
                    <input type="text" name="coupon" ref="couponInput" /><button class="lw-btn" @click="redeemCouponAction">Redeem</button>                                       
                </div>
                <div v-else class="learnworlds-main-text  learnworlds-main-text-large learnworlds-element">
                    Coupon: {{activeCoupon.name}}  <button class="lw-btn" @click="removeCouponAction">Remove</button>
                    <span v-if="hasInterval">
                        {{couponIntervalText}}
                    </span>
                    <div>
                        {{couponDiscountedPrice}}
                    </div>           
                    
                </div>
                <div v-if="couponErrors" class="learnworlds-main-text  learnworlds-main-text-normal learnworlds-element">
                    <p v-for="error in couponErrors">{{error.message}}</p>
                </div>
            </div>
        </div>
        
        <div class="mb-3rem with-flexible-parts js-lw-flexible-wrapper  js-same-content-child">
            <span data-node-type="icon" class="flexible-part   learnworlds-icon learnworlds-overline-text fas fa-tags"></span>
            <div class="flexible-part">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom" >
                    Price
                </div>
                <div v-if="productData.discountFlag" class="learnworlds-main-text  learnworlds-main-text-large learnworlds-element">                    
                    <span style="text-decoration: line-through;">{{formatPrice(productData.price)}}</span> 
                    <span>{{formatPrice(productData.discountPrice)}}</span>                     
                </div>
                <div v-else class="learnworlds-main-text  learnworlds-main-text-large learnworlds-element">
                    {{formatPrice(productData.price)}}
                    <span v-if="hasInterval"> / {{subscriptionIntervalText}} </span>
                </div>
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom" >
                    Final Price
                </div>
                <div class="learnworlds-main-text  learnworlds-main-text-large learnworlds-element">
                    {{formatPrice(finalPrice)}}
                </div>
            </div>
        </div>


        <div class="learnworlds-button-wrapper lw-content-block learnworlds-element js-same-content-wrapper">
            <button @click="initCheckout"  class=" learnworlds-button learnworlds-button-large learnworlds-button-solid-light learnworlds-element full-width">
                <span>Continue</span>
            </button>
        </div>

        <label class="checkbox-label with-flexible-parts" for="promoEmails">
            <input class="checkbox flexible-part" type="checkbox" id="promoEmails" name="promoEmails" checked></input>
            <div class="checkbox-box lw-brand-border flexible-part">
                <span class="learnworlds-icon learnworlds-heading3-small fas fa-check"></span>
            </div>
            <div class="flexible-part">
                <div class="  learnworlds-main-text  learnworlds-main-text-small learnworlds-element">
                    I agree with <a href="#" target="_new">Privacy and terms</a>
                </div>
            </div>
        </label>  
    </div>
</template>
<script>
export default {
        name: "TemplateMixin",
        mixins: [
            
        ],        
        computed:{
            componentName(){
                return this.$options.name;
            }
        }
}
</script>